import { LazyLoad } from '@petconsole/pure-fe-mui';

const LostPetAdmin = LazyLoad(() => import('./LostPetAdmin'));

export { LostPetAdmin };
